// Report-param grammar for the info-view histogram, ported from the coffee shell
// (importReportParams / updateReportParams / export).
//
// One value is stored: how many bins the histogram is drawn with. The chart opens on the number
// the report author fixed, or on the first one the question offers, and only a number the
// researcher picked themselves is written back.

export const resolveDefaultPeriod = ({ format, bars = [] } = {}) =>
  undefined === format?.bars ? bars[0] : String(format.bars)

export const resolveReportParams = ({ params = {}, format, bars } = {}) => ({
  period: params.hg?.period || resolveDefaultPeriod({ format, bars })
})

export const calcReportParamsSection = (state = {}, { format, bars } = {}) => ({
  hg: state.period === resolveDefaultPeriod({ format, bars }) ? null : { period: state.period }
})

// The state the pptx / summary exporters read off the chart.
export const calcExportData = (state = {}) => ({ period: state.period })
